import { get } from '@/utils/request'

/**
 * 配置相关 API
 */

/**
 * 获取应用静态配置
 * @param {Object} options - 请求配置
 * @returns {Promise<Object>} 应用静态配置
 */
export function getStaticConfig(options = {}) {
  return get('/members/v1/config/static', {}, {
    ...options,
  })
}
